import React, { useEffect, useState } from 'react'
import transition from '../components/transition'
import ServiceBanner from './ServiceBanner'
import Services from '../components/Services'
import ServiceDescription from '../components/ServiceDescription'
import ProjectsShowcase from '../components/ProjectsShowcase'
import { logoDesignProjects } from '../content/projects'
import Pricing from '../components/Pricing'
import { mobileAppPackages } from '../content/pricing'
import CallToAction from '../components/CallToAction'
import Form from '../components/Form'
import { socialMediaServices } from '../content/services'

const LogoDesign = () => { 
    const [slider, setSlider] = useState([])
    useEffect(() => {
        setSlider([
            logoDesignProjects.slice(0, 6).map(item => item.fullImage),
            logoDesignProjects.slice(6, 12).map(item => item.fullImage)
        ])
    }, [])
    return (
        <>
            <ServiceBanner imgContain={true} title="Social Media Marketing" desc="Social media marketing connects businesses with customers on platforms like Facebook, Instagram, and LinkedIn, boosting brand awareness, loyalty, and sales. It's essential for growth." slider={slider} />
            <ServiceDescription title="Present your brand on social media with standout, unique content that grabs attention and drives engagement." paragraph={[
                `We craft social media content with tailored visuals, colors, and themes that reflect your brand’s vision. These elements create a strong foundation to make your posts instantly stand out.`,
                '‍We create social media content with imaginative components, versatile logos, and necessary text or images that work seamlessly across platforms. Our expertise lies in designing logos that excel with monochromatic color themes.'
            ]} />
            <Services services={socialMediaServices} />
            <ProjectsShowcase projects={logoDesignProjects} />
            <Pricing data={mobileAppPackages} />
            <CallToAction title='Are You Prepared to Boost Your Online Image' subHeading="With the help of our knowledgeable web design team, turn your ideas into magnificent websites." paragraph="We will walk you through every stage of the process, from conception to launch." />
            <Form />
        </>
    )
}

export default transition(LogoDesign)
